import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * alpha-team
 * CLOUDWEB-17799: Качество. Корзина. Возможность выделить более 100 файлов в Корзине
 */
export const seriallyClearBinFeature: boolean = getFeature('serially-clear-bin');
